import{apiGet as o}from"@danfoss-source/core";import{AlgoliaApiEndpointEnum as r}from"../consts.js";const s=async(s,t,c)=>o(`${s}/${r.HeroAttributes}/${t}`,c);export{s as fetchAlgoliaHeroFilters};
